var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic_menu_compras",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Componente_189_1",
    "data-name": "Componente 189 \\u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5677",
    "data-name": "Grupo 5677",
    transform: "translate(-126 -11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_110",
    "data-name": "Uni\\xF3n 110",
    d: "M21894,7808h-5a1,1,0,0,1-1-1v-8.823l-1.926-4.806a1,1,0,0,1,.93-1.374h5a1,1,0,0,1,.93.626l1.07,2.68,1.072-2.68a.993.993,0,0,1,.93-.626h9a1,1,0,0,1,.924,1.374l-1.924,4.819V7807a1,1,0,0,1-1,1Zm1-2h7v-7h-7Zm-5,0h3v-7h-3Zm12.324-9,1.2-3h-6.846l-1.2,3Zm-9.8,0-1.2-3h-2.85l1.2,3Z",
    transform: "translate(-21758 -7777)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2376",
    "data-name": "Rect\\xE1ngulo 2376",
    width: 24,
    height: 24,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBox);
export default __webpack_public_path__ + "static/media/ic_box.5a211642aa0dcb89a89f679c21523762.svg";
export { ForwardRef as ReactComponent };